import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CheckMarkIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='checkMark'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M 17.543 8.088 L 9.966 15.537 L 6.222 12.859'
				stroke={props?.color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CheckMarkIcon;
